export default __webpack_public_path__ + "static/media/vijaywadaTempleOne.11604308.png";